module.exports = __webpack_public_path__ + "static/media/internet.fc5540c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/internet.png
// module id = 619
// module chunks = 0